// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__q4NN0","messages":"Chat_messages__3zrF0","dateDivider":"Chat_dateDivider__1hJu-"};